<template>
  <div>
    <div>
      <a-button type="default" @click="$router.back()"><a-icon type="rollback" /> Quay lại</a-button>
    </div>
    <br>
    <a-card :title="`Danh sách Threads - ${id}`" class="root-card">
      <div id="actions">
        <div class="left-actions">
          <a-button type="primary" @click="handleFetchThreads"><a-icon type="reload" /> Làm mới</a-button>
        </div>
        <div class="right-actions">
          <a-switch :checked="autoReloadCheck" checked-children="Tự động làm mới" un-checked-children="Tự động làm mới" default-checked @change="onChangeAutoReloadSwitch" />
        </div>
      </div>
      <br />
      <a-table
        id="threads-table"
        :columns="tables.threadsTable.columns"
        :data-source="threads"
        :loading="loading.threadsTable"
        :pagination="tables.threadsTable.pagination"
        :scroll="{ y: 350 }"
      bordered>
        <a-badge :overflowCount="9999999" slot="stt" slot-scope="stt, record, index" show-zero :count="((tables.threadsTable.pagination.current - 1)* tables.threadsTable.pagination.pageSize) + index + 1" :number-style="{ backgroundColor: '#999' }" />
        <a-tag slot="status" slot-scope="status" :color="ThreadStatusProperties[status].color">{{ThreadStatusProperties[status].title}}</a-tag>
        <template slot="note" slot-scope="note">
          <div class="multiline-cell">{{note}}</div>
        </template>
        <span slot="time" slot-scope="time">{{(time / 1000).toFixed(1)}}s</span>
      </a-table>
    </a-card>
  </div>
</template>
<style scoped>
#actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-actions {
  display: flex;
  gap: 15px;
}

.right-actions {
  display: flex;
  gap: 15px;
}

.multiline-cell {
  white-space: pre-wrap;
}
</style>
<script>
import {mapActions} from 'vuex';

const threadListTableColumns = [
  {
    title: 'STT',
    dataIndex: 'stt',
    key: 'stt',
    scopedSlots: { customRender: 'stt' },
    width: '100px',
  },
  {
    title: 'Trạng thái',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
    width: '120px',
  },
  {
    title: 'Dữ liệu',
    dataIndex: 'input',
    key: 'input',
    scopedSlots: { customRender: 'input' },
    width: '80px',
  },
  {
    title: 'Thời gian',
    dataIndex: 'time',
    key: 'time',
    scopedSlots: { customRender: 'time' },
    width: '80px',
    align: 'center'
  },
  {
    title: 'Note',
    dataIndex: 'note',
    key: 'note',
    scopedSlots: { customRender: 'note' },
    width: '400px',
  },
];

const ThreadStatus = {
  PENDING: 0,
  RUNNING: 1,
};

const ThreadStatusProperties = {
  [ThreadStatus.PENDING]: {
    title: 'Đang Chờ'
  },
  [ThreadStatus.RUNNING]: {
    title: 'Đang Chạy',
    color: 'orange'
  },
}

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tables: {
        threadsTable: {
          columns: threadListTableColumns,
          selectedIds: [],
          pagination: {
            total: 0,
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            pageSizeOptions: ['10', '30', '50', '100', '200', '500', '1000'],
            showQuickJumper: true,
            onChange: this.handleThreadTableChange,
            onShowSizeChange: this.handleThreadTableChange,
            showTotal: (total, range) => {
              return `${range[0]} - ${range[1]} of ${total}`;
            }
          },
        },
      },
      loading: {
        threadsTable: false
      },
      visible: {

      },
      ThreadStatus,
      ThreadStatusProperties,
      app: this.$root.$children[0],
      threads: [],
      autoReloadCheck: false,
      autoReloadInterval: undefined
    };
  },
  mounted() {
    this.handleFetchThreads();
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.autoReloadInterval);
    next();
  },
  computed: {

  },
  methods: {
    ...mapActions('job', {
      getThreads: "getThreads"
    }),

    async handleFetchThreads() {
      this.app.callApi(async () => {
        this.loading.threadsTable = true;
        this.threads = await this.getThreads(this.id);
        this.loading.threadsTable = false;
      }, () => {
        this.loading.threadsTable = false;
      });
    },

    onChangeAutoReloadSwitch(checked) {
      this.autoReloadCheck = checked;

      if (checked) {
        this.autoReloadInterval = setInterval(this.handleFetchThreads.bind(this), 2000);
      } else {
        clearInterval(this.autoReloadInterval);
      }
    },

    handleThreadTableChange(page, pageSize) {
      this.tables.threadsTable.pagination.total = this.threads.length;
      this.tables.threadsTable.pagination.current = page;
      this.tables.threadsTable.pagination.pageSize = pageSize;
    },

    formatDate(date) {
      if (!date) {
        return undefined;
      }

      return new Date(date).toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },

    formatTimeDistance(start, end) {
      if (!start || !end) {
        return undefined;
      }

      start = new Date(start);
      end = new Date(end);

      const distance = Math.abs(end - start) / 1000; // Convert to seconds

      const hours = Math.floor(distance / 3600);
      const minutes = Math.floor((distance % 3600) / 60);
      const seconds = Math.round(distance % 60);

      const formattedTime = [];

      if (hours > 0) {
        formattedTime.push(`${hours}h`);
      }

      if (minutes > 0) {
        formattedTime.push(`${minutes}m`);
      }

      if (seconds > 0) {
        formattedTime.push(`${seconds}s`);
      }

      return formattedTime.join('');
    },
  }
}
</script>